module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-08.f2f572e8.jpg";